export const SLIDER_CONFIG = {
  className: "GC-RN-slider",
  centerMode: true,
  infinite: false,
  arrows: false,
  initialSlide: 0,
  speed: 500,
  touchThreshold: 40,
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
};

export const TRUST_WIDGET_CONFIG = {
  language: "en",
  culture: "US",
  theme: "light",
  width: "246px",
  height: "20px",
  template: "5419b6a8b0d04a076446a9ad",
  business: "58a605050000ff00059cd0f6",
  username: "amzscout.net",
};

export const POSTS = [
  {
    title: "AMZ Scout es lo primero que viene a la mente…",
    description: "AMZ Scout es la referencia cuando se habla de vender en Amazon. Proporciona toda la información que necesitas para encontrar el nicho perfecto y hacer crecer tu futuro negocio.",
  },
  {
    title: "Me encanta esta extensión…",
    description: "Me encanta esta extensión. La he estado usando durante un mes y me parece ergonómica, fácil de usar y confiable. El equipo de soporte de AMZScout también ha sido útil y comprensivo. Le doy 5 estrellas.",
  },
  {
    title: "Esta herramienta es imprescindible para encontrar…",
    description: "Esta herramienta es imprescindible para encontrar productos para revender con ganancias en Amazon. Muy intuitiva y con “consejos” que te guían hasta que te familiarizas con ella.",
  },
];
